// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import data from '../static/config.json'
import './filters'
import vuexI18n from 'vuex-i18n';
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

Vue.use(vuexI18n.plugin, store);

import translationsEn from '@/translations/en';
import translationsDe from '@/translations/de';
import translationsRo from '@/translations/ro';

Vue.i18n.add('en', translationsEn);
Vue.i18n.add('de', translationsDe);
Vue.i18n.add('ro', translationsRo);

Vue.i18n.set(store.state.language);

Vue.prototype.$apiUrl = data.API_URL

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js